import { render, staticRenderFns } from "./AdicionalLikelyModal.vue?vue&type=template&id=f2813676"
import script from "./AdicionalLikelyModal.vue?vue&type=script&lang=js"
export * from "./AdicionalLikelyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports